import { ChevronRightIcon, PencilIcon, XMarkIcon } from "@heroicons/react/24/outline"
import { HTMLProps, useEffect, useRef } from "react"
import Tooltip from "../Tooltip";
import openInNewTab from "../../../utils/openInNewTab";

export function IndeterminateCheckbox({
  indeterminate,
  className = '',
  ...rest
}: { indeterminate?: boolean } & HTMLProps<HTMLInputElement>) {
  const ref = useRef<HTMLInputElement>(null!)

  const primaryClasses = `checked:bg-primary-600 checked:focus:bg-primary-600 hover:checked:bg-primary-700
    indeterminate:bg-primary-600 hover:indeterminate:bg-primary-700
    focus:ring-primary-600 
  `;

  useEffect(() => {
    if (typeof indeterminate === 'boolean') {
      ref.current.indeterminate = !rest.checked && indeterminate
    }
  }, [ref, indeterminate])

  return (
    <input
      type="checkbox"
      ref={ref}
      className={className + ' p-3 cursor-pointer ' + primaryClasses}
      {...rest}
    />
  )
}

// {
//       id: 'select',
//       header: ({ table }: any) => (
//         <IndeterminateCheckbox
//           {...{
//             checked: table.getIsAllRowsSelected(),
//             indeterminate: table.getIsSomeRowsSelected(),
//             onChange: table.getToggleAllRowsSelectedHandler(),
//           }}
//         />
//       ),
//       cell: ({ row }: any) => (
//         <div className="flex justify-center items-center flex-1 p-1" onClick={(e) => e.stopPropagation()}>
//           <IndeterminateCheckbox
//             {...{
//               id: row.original.id,
//               checked: row.getIsSelected(),
//               disabled: !row.getCanSelect(),
//               indeterminate: row.getIsSomeSelected(),
//               onChange: row.getToggleSelectedHandler(),
//             }}
//           />
//           <button
//             onClick={(e) => { e.stopPropagation(); row.toggleExpanded(); }}
//             style={{ transform: `rotate(${!row.getIsExpanded() ? "0" : "-270"}deg)` }}
//             className="ml-3 p-1 transition duration-500 cursor-pointer border border-gray-400 rounded-full hover:bg-gray-200"
//           >
//             {/* {row.getIsExpanded() ? <ChevronDownIcon className="h-4 w-4" /> : <ChevronRightIcon className="h-4 w-4"/>} */}
//             <ChevronRightIcon className="h-4 w-4" />
//           </button>
//         </div>
//       ),
//     },

// return the above 
export default function TableCheckboxCol(showDropdown = true, showCheckbox = true, showEdit = false, editUrl = "") {
  return {
    id: 'select',
    header: ({ table }: any) => showCheckbox ? (
      <div className="flex justify-center items-center flex-1 gap-x-2 p-4">
        <IndeterminateCheckbox
          {...{
            checked: table.getIsAllRowsSelected(),
            indeterminate: table.getIsSomeRowsSelected(),
            onChange: table.getToggleAllRowsSelectedHandler(),
          }}
        />
        <button
          onClick={(e) => { if (table.getState().rowSelection) table.resetRowSelection(); }}
          className={`p-1 transition duration-500 cursor-pointer border border-gray-400 rounded-full hover:bg-gray-200
            ${table.getSelectedRowModel().rows.length === 0 ? "pointer-events-none" : "border-primary-700 bg-primary-600 hover:bg-primary-700 text-white"}
          `}
        >
          <XMarkIcon className="h-4 w-4" />
        </button>
      </div>
    ) : null,
    cell: ({ row }: any) => (
      <div className="flex justify-center items-center flex-1 gap-x-2 p-1" onClick={(e) => e.stopPropagation()}>
        {showCheckbox && (
          <IndeterminateCheckbox
            {...{
              id: row.original.id,
              checked: row.getIsSelected(),
              disabled: !row.getCanSelect(),
              indeterminate: row.getIsSomeSelected(),
              onChange: row.getToggleSelectedHandler(),
            }}
          />
        )}
        <div className="flex flex-col gap-y-2">
          {showEdit && editUrl !== "" && (
            <Tooltip content="Edit Listing">
              <button
                onClick={(e) => { openInNewTab(`${editUrl}/${row.original.id}`) }}
                className="p-1 transition duration-500 cursor-pointer border border-gray-400 rounded-full hover:bg-gray-200"
              >
                <PencilIcon className="h-4 w-4" />
              </button>
            </Tooltip>
          )}

          {showDropdown &&
            <Tooltip content={row.getIsExpanded() ? "Close Details" : "Show Details"}>
              <button
                onClick={(e) => { e.stopPropagation(); row.toggleExpanded(); }}
                style={{ transform: `rotate(${!row.getIsExpanded() ? "0" : "-270"}deg)` }}
                className="p-1 transition duration-500 cursor-pointer border border-gray-400 rounded-full hover:bg-gray-200"
              >
                <ChevronRightIcon className="h-4 w-4" />
              </button>
            </Tooltip>
          }
        </div>

      </div>
    ),
  }
}